/* global axios */
import ApiClient from '../ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get({
    inboxId,
    status,
    assigneeType,
    page,
    labels,
    teamId,
    conversationType,
    sortBy,
    updatedWithin,
  }) {
    return axios.get(this.url, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
        status,
        assignee_type: assigneeType,
        page,
        labels,
        conversation_type: conversationType,
        sort_by: sortBy,
        updated_within: updatedWithin,
      },
    });
  }

  filter(payload) {
    return axios.post(`${this.url}/filter`, payload.queryData, {
      params: {
        page: payload.page,
      },
    });
  }

  search({ q }) {
    return axios.get(`${this.url}/search`, {
      params: {
        q,
        page: 1,
      },
    });
  }

  toggleStatus({ conversationId, status, snoozedUntil = null }) {
    return axios.post(`${this.url}/${conversationId}/toggle_status`, {
      status,
      snoozed_until: snoozedUntil,
    });
  }

  togglePriority({ conversationId, priority }) {
    return axios.post(`${this.url}/${conversationId}/toggle_priority`, {
      priority,
    });
  }

  assignAgent({ conversationId, agentId, takeOverConversation = false }) {    
    const data = { 
      assignee_id: agentId
    };
    
    if (takeOverConversation !== undefined) {
      data.take_over_conversation = takeOverConversation;
    }

    return axios.post(
      `${this.url}/${conversationId}/assignments`,
      data
    ).catch(error => {
      console.error("Erro na requisição:", error.response ? error.response.data : error.message);
      throw error;
    });
  }

  assignTeam({ conversationId, teamId }) {
    const params = { team_id: teamId };
    return axios.post(`${this.url}/${conversationId}/assignments`, params)
      .catch(error => {
        if (error.response.data.error) {
          throw new Error(error.response.data.error);
        }
        throw error;
      });
  }

  markMessageRead({ id }) {
    return axios.post(`${this.url}/${id}/update_last_seen`);
  }

  markMessagesUnread({ id }) {
    return axios.post(`${this.url}/${id}/unread`);
  }

  toggleTyping({ conversationId, status, isPrivate }) {
    return axios.post(`${this.url}/${conversationId}/toggle_typing_status`, {
      typing_status: status,
      is_private: isPrivate,
    });
  }

  mute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/mute`);
  }

  unmute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/unmute`);
  }

  meta({ inboxId, status, assigneeType, labels, teamId, conversationType }) {
    return axios.get(`${this.url}/meta`, {
      params: {
        inbox_id: inboxId,
        status,
        assignee_type: assigneeType,
        labels,
        team_id: teamId,
        conversation_type: conversationType,
      },
    });
  }

  sendEmailTranscript({ conversationId, email }) {
    return axios.post(`${this.url}/${conversationId}/transcript`, { email });
  }

  getPdfTranscript(conversationId) {
    return axios.get(`${this.url}/${conversationId}/pdf_transcript`, {
      responseType: 'blob',
    });
  }

  updateCustomAttributes({ conversationId, customAttributes }) {
    return axios.post(`${this.url}/${conversationId}/custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  fetchParticipants(conversationId) {
    return axios.get(`${this.url}/${conversationId}/participants`);
  }

  updateParticipants({ conversationId, userIds, emails }) {
    const payload = {};
    if (userIds) payload.user_ids = userIds;
    if (emails) payload.emails = emails;
    
    return axios.patch(`${this.url}/${conversationId}/participants`, payload);
  }
  
  addEmailParticipant({ conversationId, email }) {
    return axios.post(`${this.url}/${conversationId}/participants`, {
      emails: [email]
    });
  }
  
  removeEmailParticipant({ conversationId, email }) {
    return axios.delete(`${this.url}/${conversationId}/participants`, {
      data: { emails: [email] }
    });
  }
  
  getAllAttachments(conversationId) {
    return axios.get(`${this.url}/${conversationId}/attachments`);
  }

  getBotAgentConversationsIds() {
    return axios.get(`${this.url}/bot_agent_conversations_ids`);
  }

  checkAccess(conversationId) {
    return axios.get(`${this.url}/${conversationId}/access`);
  }

  toggleIA(conversationId) {
    return axios.post(`${this.url}/${conversationId}/toggle_ia`);
  }
}

export default new ConversationApi();